import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { GetDescendantShortLinksWithPaginationDto } from 'src/app/core/api/models';
import { ShortLinksService } from 'src/app/core/api/services';
import { DynamicTableService } from 'src/app/core/services/dynamic-table.service';
import { ShortLinksComponent } from '../short-links.component';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { ShortLinksFormComponent } from "../short-links-form/short-links-form.component";


@Component({
    selector: 'app-descendant-short-links',
    templateUrl: './descendant-short-links.component.html',
    imports: [BaseIndexModule, ShortLinksFormComponent]
})
export class DescendantShortLinksComponent
  extends ShortLinksComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.shortLinks;
  protected currentService = inject(ShortLinksService);
  paginationApiMethodName: string = this.currentService.shortLinksGetDescendantShortLinksWithPagination.name;
  auditApiMethodName: string = this.currentService.shortLinksGetShortLinksAudit.name;
  modelWithPagination$: Observable<any>; //CustomResultOfPaginatedListOfGetDescendantShortLinksWithPaginationDto>; TODO torbatian
  items$: Observable<Array<GetDescendantShortLinksWithPaginationDto>>;

  //#endregion

  constructor(
    public dynamicTableService: DynamicTableService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.pageConfig.title = this.pageVocabs + 'descendantTitle';
    this.pageConfig.showAddBtn = false;
    this.pageConfig.showAuditBtn = true;
  }

  configTableColumns() {
    this.tableColumns = [
      { title: this.localizer.title, name: 'title', hasSearch: true },
      {
        title: `${this.tableVocabs}shortUrl`,
        name: 'shortUrl',
        hasSearch: true,
      },
      { title: `${this.tableVocabs}mainUrl`, name: 'mainUrl', hasSearch: true },
      {
        title: this.localizer.organizationName,
        name: 'organizationName',
        hasSearch: true,
      },
      {
        title: 'common.isActive',
        name: 'isActive',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}urlType`,
        name: 'urlType',
        hasSearch: true,
        type: 'enum',
        enumName: 'UrlType',
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        type: 'dateTime',
        hasSearch: true,
      },
    ];
  }

  //#endregion
}
